var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-table"},[_c('div',{staticClass:"nuttrema-table__header"},[_c('div',{staticClass:"nuttrema-table__header__row"},[_vm._t("header")],2)]),_vm._v(" "),_c('div',{staticClass:"nuttrema-table__body"},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d4f8fd0","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/table/nuttrema-table.vue
// module id = 3033
// module chunks = 0